module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM15.718 16.742l-6.662 6.964a.934.934 0 0 1-1.358 0L6.34 22.284a1.032 1.032 0 0 1 0-1.418l4.624-4.836-4.682-4.898a1.037 1.037 0 0 1 0-1.422L7.64 8.292a.934.934 0 0 1 1.358 0l6.72 7.028a1.037 1.037 0 0 1 0 1.422zm10 0l-6.662 6.964a.934.934 0 0 1-1.358 0l-1.358-1.422a1.032 1.032 0 0 1 0-1.418l4.624-4.836-4.682-4.898a1.037 1.037 0 0 1 0-1.422l1.358-1.418a.934.934 0 0 1 1.358 0l6.722 7.028a1.04 1.04 0 0 1-.002 1.422z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-angle-quote-2.js
// module id = 1382
// module chunks = 14